import { FC } from 'react';
import { Moment } from 'moment';
import { useBehavioralInsightsQuery } from '../hooks';
import { useAngularListSegmentContext } from '../../contexts/AngularListSegmentContext';
import { useInsightsQueryContext } from './InsightsQueryContext';
import { BehaviorQueryContext, BehaviorQueryState } from './BehaviorQueryContext';

export const BehaviorQueryContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { listDetails } = useAngularListSegmentContext();
  const { startDate, endDate } = useInsightsQueryContext();

  const insightQueryParam = listDetails
    ? {
        ...listDetails,
        startDate: (startDate as Moment | null)?.toISOString(),
        endDate: (endDate as Moment | null)?.toISOString(),
      }
    : undefined;

  const {
    data: behavior,
    error: behaviorError,
    isError: isBehaviorError,
    isLoading: isBehaviorLoading,
    refetch: refetchBehavior,
  } = useBehavioralInsightsQuery(insightQueryParam);

  const context: BehaviorQueryState = {
    isBehaviorError,
    behaviorError,
    isBehaviorLoading,
    refetchBehavior,
    behavior,
    ...behavior,
  };

  return <BehaviorQueryContext.Provider value={context}>{children}</BehaviorQueryContext.Provider>;
};
